var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignageIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 32,
    viewBox: "0 0 54 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.8964 0.0629883H2.67358C1.22506 0.0629883 0.0507812 1.23724 0.0507812 2.68575V29.3143C0.0507812 30.7628 1.22506 31.9371 2.67358 31.9371H50.8964C52.3449 31.9371 53.5191 30.7628 53.5191 29.3143V2.68575C53.5191 1.23724 52.3449 0.0629883 50.8964 0.0629883Z",
    fill: "#F4D25E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6627 3.70459H5.9096C4.72982 3.70459 3.77344 4.66099 3.77344 5.84076V26.1588C3.77344 27.3386 4.72982 28.295 5.9096 28.295H47.6627C48.8425 28.295 49.7988 27.3386 49.7988 26.1588V5.84076C49.7988 4.66099 48.8425 3.70459 47.6627 3.70459Z",
    fill: "#F1583C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4405 7.41113H9.12641C8.22385 7.41113 7.49219 8.14284 7.49219 9.0454V22.958C7.49219 23.8605 8.22385 24.5922 9.12641 24.5922H44.4405C45.343 24.5922 46.0748 23.8605 46.0748 22.958V9.0454C46.0748 8.14284 45.343 7.41113 44.4405 7.41113Z",
    fill: "#F4D25E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3126 11.1323H12.2602C11.6484 11.1323 11.1523 11.6284 11.1523 12.2403V19.7627C11.1523 20.3746 11.6484 20.8706 12.2602 20.8706H41.3126C41.9244 20.8706 42.4205 20.3746 42.4205 19.7627V12.2403C42.4205 11.6284 41.9244 11.1323 41.3126 11.1323Z",
    fill: "#F1583C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5684 16.9443L29.426 24.5953H24.1406L25.9983 16.9443C26.5195 17.0096 27.0471 17.0096 27.5684 16.9443Z",
    fill: "#F4D25E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7853 16.366C27.4564 16.366 28.0003 15.822 28.0003 15.151C28.0003 14.48 27.4564 13.936 26.7853 13.936C26.1142 13.936 25.5703 14.48 25.5703 15.151C25.5703 15.822 26.1142 16.366 26.7853 16.366Z",
    fill: "#F4D25E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignageIcon);
export default __webpack_public_path__ + "static/media/signage-icon.b2904b8c7974ee56a436f89f5f9160df.svg";
export { ForwardRef as ReactComponent };